export const apiUrl = 'https://dev-api.itstaste.com/api'
export const defaultPagination = 20
export const perPageList =  [20, 50, 100]
export const is_live = false;

export const APP_NAME = 'nimble'
export const APP_PORTAL = 'staff'
export const APP_TENANT = 'nimble'
export const APP_PUSHER_KEY = 'ac822ec57919117792dd'
export const APP_SAGE_KEY = 'Rur9VfUC8WY0REKgmzPN6K7ay6jknuDy'
export const APP_SAGE_AUTH_URL = 'https://id.sage.com/authorize?audience=s200ukipd/sage200'
export const SUPPORT_APP_URL = 'https://dev-support.souqbox.io'
export const AI_CHAT_API_URL = `https://dev-ai-chat-api.itstaste.com/api/v1`;